import _defineProperty from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty";
import * as types from "@/store/constants/types";
export default _defineProperty({}, types.UPDATE_INIT_IAP_STATUS, function (state, payload) {
  state.initIapStatus = payload;
});